module.exports = "/images/vendor/desiigner-svg/svg/ui/clock.svg?8f921ce0f093edacb2ae3a06b7f72a1e";